import React, { SVGProps } from 'react';

function Check3(props: SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill, ...rest } = props;
  return (
    <svg fill="none" height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M7.625 9.5001L10.37 13.3426C10.483 13.5008 10.6308 13.631 10.8019 13.7231C10.9731 13.8153 11.1631 13.867 11.3574 13.8742C11.5517 13.8815 11.745 13.8441 11.9226 13.7649C12.1002 13.6858 12.2572 13.5669 12.3817 13.4176L21.375 2.62427"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M13 4H6.625C4.41586 4 2.625 5.79086 2.625 8V17.5C2.625 19.7091 4.41586 21.5 6.625 21.5H16.125C18.3341 21.5 20.125 19.7091 20.125 17.5V13"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

Check3.displayName = 'Check3';

export default Check3;
